import { render, staticRenderFns } from "./LeadFollowUpAutomationPanel.vue?vue&type=template&id=54287979&scoped=true&"
import script from "./LeadFollowUpAutomationPanel.vue?vue&type=script&lang=js&"
export * from "./LeadFollowUpAutomationPanel.vue?vue&type=script&lang=js&"
import style0 from "./LeadFollowUpAutomationPanel.vue?vue&type=style&index=0&id=54287979&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54287979",
  null
  
)

export default component.exports